import React from 'react';
import FontAwesome from 'react-fontawesome';

export default class Message extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isAuthenticated: undefined,
            editable: false,
            message: undefined,
            updatedBody: ''
        }
    }

    componentDidMount() {
        this.setState({
            message: this.props.messageSnap.val(),
            isAuthenticated: this.props.messageSnap.val().author.uid === this.props.authenticatedUser.uid,
        })
    }

    handleMouseEnter() {
        if (this.state.isAuthenticated) {
            this.setState({
                canEdit: true
            })
        }
    }

    handleMouseOut() {
        if (this.state.isAuthenticated) {
            this.setState({
                canEdit: false
            })
        }
    }

    handleEdit() {
        this.setState({
            editable: true,
        })

    }
    handleDelete() {
        let messageRef = this.props.messageSnap.ref;
        if (this.state.isAuthenticated) {
            messageRef.remove()
        }

    }

    handleInput(evt) {
        this.setState({
            updatedBody: evt.target.value,
        })
    }
    handSubmit(evt) {
        evt.preventDefault();
        this.props.messageSnap.ref.update({ body: this.state.updatedBody })
        this.setState({
            editable: false,
        })
    }
    render() {

        let message = this.props.messageSnap.val();
        let date = new Date(message.createdAt);

        return (
            <li className="media my-2 message p-2" onMouseEnter={() => this.handleMouseEnter()} onMouseLeave={() => this.handleMouseOut()} onTouchStart={() => this.handleMouseEnter()} onTouchCancel={() => this.handleMouseOut()}>
                <img className="mr-2 img-thumbnail img-fluid rounded border-0" src={message.author.photoURL} alt={message.author.displayName} width={50} />
                <div className="media-body">
                    <div className="d-flex" style={{ minHeight: 40 }}>
                        <div className="mr-auto pr-0">
                            <b className="mt-0 mb-1 mr-2">{message.author.displayName}</b>
                            <small className="text-secondary">{date.toLocaleTimeString()}</small>
                        </div>

                        <div>
                            {this.state.canEdit
                                ?
                                <div>
                                    <button type="button" className="btn btn-primary btn-sm mr-2 inline" onClick={() => this.handleEdit()}><FontAwesome name="edit" /></button>
                                    <button type="button" className="btn btn-danger btn-sm mr-2 inline" onClick={() => this.handleDelete()}><FontAwesome name="trash" /></button>
                                </div>
                                :
                                undefined
                            }
                        </div>
                    </div>
                    {
                        this.state.editable
                            ?

                            <form onSubmit={(evt) => this.handSubmit(evt)}>
                                <div className="form-group row">
                                    <div className="col">
                                        <input type="text" className="form-control" id="messageEdit" defaultValue={message.body} onInput={(evt) => this.handleInput(evt)} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-sm-10">
                                        <button type="submit" className="btnbtn-sm btn-light mr-4" onClick={() => this.setState({ editable: false })}>Cancel</button>
                                        <button type="submit" className="btn btn-sm btn-success">Save Changes</button>
                                    </div>
                                </div>
                            </form>
                            :
                            <p>{message.body}</p>
                    }
                </div>
            </li>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Message.js